export const ADD_MARKET_PRODUCTS = 'ADD_MARKET_PRODUCTS';
const SET_MARKETS_SELECTED_TAB = 'SET_MARKETS_SELECTED_TAB';
const FETCH_MARKET_BANNERS = 'FETCH_MARKET_BANNERS';

export { SET_MARKETS_SELECTED_TAB, FETCH_MARKET_BANNERS };
